var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.1875C2.78984 0.1875 0.1875 2.78984 0.1875 6C0.1875 9.21016 2.78984 11.8125 6 11.8125C9.21016 11.8125 11.8125 9.21016 11.8125 6C11.8125 2.78984 9.21016 0.1875 6 0.1875ZM6 1.3125C8.59059 1.3125 10.6875 3.40901 10.6875 6C10.6875 8.59059 8.59099 10.6875 6 10.6875C3.40941 10.6875 1.3125 8.59099 1.3125 6C1.3125 3.40941 3.40901 1.3125 6 1.3125ZM9.28603 4.36563L8.75784 3.83318C8.64846 3.72291 8.47038 3.72218 8.36011 3.83159L5.04717 7.1179L3.6458 5.70516C3.53641 5.59488 3.35834 5.59416 3.24806 5.70354L2.71559 6.23173C2.60531 6.34111 2.60459 6.51919 2.71399 6.62948L4.84167 8.77439C4.95105 8.88466 5.12913 8.88539 5.23941 8.77598L9.28446 4.76339C9.39471 4.65398 9.39541 4.47591 9.28603 4.36563Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.4eab38d6.svg";
export { ForwardRef as ReactComponent };